/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's opyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

/**
 * Centralized react-query keys for the agenda feature.
 */
export const agendaKeys = {
  all: (agencyId: string) => ['agenda', agencyId] as const,
  calendars: (agencyId: string) => ['agenda', agencyId, 'calendars'] as const,
  events: (agencyId: string, rangeKey: string) =>
    ['agenda', agencyId, 'events', rangeKey] as const,
};
